import { createSlice } from "@reduxjs/toolkit";

const authTokenResponseData = {};
const visualizeInfo = null;
const cloneInfo = null;
const notificationInfo = null;
const adminName = null;
const bdepanelType = null;
const bdeshopID = null;
const logoutSession = false; 

const AuthTokenSlice = createSlice({
  name: "authtoken",
  initialState: {
    authTokenResponseData,
    visualizeInfo,
    cloneInfo,
    notificationInfo,
    adminName,
    bdepanelType,
    bdeshopID,
    logoutSession
  },

  reducers: {

    resSetAuthToken(state,action) {
      state.authTokenResponseData = authTokenResponseData;
      state.visualizeInfo = visualizeInfo;
      state.cloneInfo = cloneInfo;
      state.notificationInfo = notificationInfo;
      state.adminName = adminName;
      state.bdepanelType = bdepanelType;
      state.bdeshopID = bdeshopID;
      state.logoutSession = logoutSession;
    },
    setAuthTokenResponseData(state, action) {
      // The session is in httpOnly cookies; never keep a token in (persisted) Redux state
      const { accessToken, tokenType, ...sessionData } = action.payload || {};
      state.authTokenResponseData = sessionData;
      state.visualizeInfo = action.payload?.visualizeInfo ?? true;
      state.cloneInfo = action.payload?.cloneInfo ?? true;
      state.notificationInfo = action.payload?.notificationInfo;
      state.adminName = action.payload?.adminName;
      state.bdepanelType = action.payload?.bdepanelType;
      state.bdeshopID = action.payload?.bdeshopID;
      state.isLegacyDashboard = action.payload?.isLegacyDashboard ?? false
    },
    setVisualizeInfo(state, action) {
      state.visualizeInfo = action.payload;
    },
    setCloneInfo(state, action) {
      state.cloneInfo = action.payload;
    },
    setNotificationInfo(state, action) {
      state.notificationInfo = action.payload;
    },
    setActiveSession(state) {
      state.authTokenResponseData = {...state.authTokenResponseData, activeSessions: false};
    },
    setLogoutSession(state, action) {
      state.logoutSession = action.payload;
    }
  },
  
});

export const {
  setAuthTokenResponseData,
  setVisualizeInfo,
  setCloneInfo,
  setNotificationInfo,
  resSetAuthToken,
  setActiveSession,
  setLogoutSession
} = AuthTokenSlice.actions;

export default AuthTokenSlice.reducer;
